module.exports = __webpack_public_path__ + "emptyState.svg?c0dab7ec07786d3aaada7bbadfb4ce59";